module.exports = __webpack_public_path__ + "img/bjoernheinzelmann.97f0aeb5.jpg";